export default __webpack_public_path__ + "static/media/inca1.260132cb.PNG";